import { useQuery } from '@tanstack/react-query';
import { getSubClientDetails } from '../services/common/apiCommon';
import { useError } from '../context/ErrorContext';
import { useGetSubClientId } from './useGetSubClientId';

type SubClientDetailsResponse = {
    isHaulingBusinessTypeEnabled: boolean;
    isTransferStationBusinessTypeEnabled: boolean;
    isWaterMeterBusinessTypeEnabled: boolean;
    scaleDetailModel: { scaleNumber: number; scaleHouseId: number } | null;
    mergeFieldsForRegularRate: { integer: number; string: string }[];
    mergeFieldsForSpecialServiceRate: { integer: number; string: string }[];
    billingInvoicePdfConfigDetails: {
        fontSize: number;
        fontType: string;
        maxLineCharLimit: number;
    } | null;
};

const transformData = (data: SubClientDetailsResponse) => {
    return {
        ...data,
        mergeFieldsForRegularRate: data?.mergeFieldsForRegularRate?.map(item => ({
            mergeField: item?.string,
            maxCharacters: item?.integer,
        })),
        mergeFieldsForSpecialServiceRate: data?.mergeFieldsForSpecialServiceRate?.map(item => ({
            mergeField: item?.string,
            maxCharacters: item?.integer,
        })),
    };
};

export function useGetSubClientDetails() {
    const { handleErrorAction } = useError();
    const { subClientId = "", isSubClient } = useGetSubClientId();
    return useQuery({
        queryKey: ['subClientDetails', subClientId],
        queryFn: async () => {
            const { data } = await getSubClientDetails({ subClientId });
            return data as SubClientDetailsResponse;
        },
        onError: (error: Error) => handleErrorAction(error),
        enabled: isSubClient,
        staleTime: 5 * 60 * 1000,
        select: transformData,
    });
}